import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from "react-router-dom";
import { Alert } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import PrivacyNotice from './PrivacyNotice';
import SignIn from './SignIn';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as utility from '../data/Utility';

class HomeInternal extends React.Component {
    constructor(props) {
        super(props);

        const error = utility.propCheck(props.error, false);
        const message = utility.propCheck(props.message, "");
        this.state = {
            error: error,
            message: message
        };

        this.clearMessage = this.clearMessage.bind(this);
    }

    clearMessage() {
        this.setState({
            error: false,
            message: ""
        });
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
    }

    render() {
        const accountsState = this.props.accountsState;
        var authenticated = (
            Accounts.authenticatedAllRoles(accountsState) &&
            !accountsState.fetching
        );
        const authenticatedAccount = accountsState.authenticatedAccount;
        const authenticatedPrivacyAccepted = accountsState.authenticatedPrivacyAccepted;
        var error = this.state.error;
        const redirect = (
            authenticated &&
            authenticatedPrivacyAccepted
        );
        var redirectPath = paths.selectStudy;
        var physicianRole = false;
        const privacyNotice = (
            authenticated &&
            !authenticatedPrivacyAccepted
        );
        var message = this.state.message;

        if (authenticated && authenticatedAccount != null) {
            physicianRole = authenticatedAccount.role === Accounts.accountRoles.Physician;
            if (!authenticatedAccount.emailConfirmed) {
                error = true;
                message = "Account is not confirmed - HCS Portal account must be confirmed via email prior to signing in.";
            }
        }

        if (physicianRole) {
            redirectPath = paths.selectRecord;
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        return (
            <div>
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                {!authenticated && <SignIn clearCallback={this.clearMessage} />}
                {privacyNotice && <PrivacyNotice />}
                {redirect && <Redirect to={redirectPath} />}
            </div>
        );
    }
}

const HomeConnect = connect(
    state => ({
        accountsState: state.accounts
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch)
    })
)(HomeInternal);

export default class Home extends React.Component {
    render() {
        var error = false;
        var message = "";

        const propsSearch = this.props.location.search;
        const propsState = this.props.location.state;
        if (propsSearch != null) {
            const status = propsSearch.toLowerCase();
            if (status === "?emailconfirm") {
                message = "Account confirmation email sent - HCS Portal account must be confirmed via email prior to signing in.";
            }
            else if (status === "?emailsuccess") {
                message = "Account successfully confirmed.";
            }
            else if (status === "?emailerror") {
                error = true;
                message = "Account confirmation error - please contact HCS support for assistance.";
            }
            else if (status === "?emailreset") {
                message = "Account password reset email sent.";
            }
            else if (status === "?resetsuccess") {
                message = "Password successfully reset.";
            }
        }
        else if (propsState != null &&
            propsState.message != null) {
            message = propsState.message;
        }

        return (
            <ErrorBoundary>
                <HomeConnect error={error} message={message} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home.js